import React from 'react'
import Icon from '../misc/Icons'
import UpgradeProFeaturesSymbolRow from './UpgradeProFeaturesSymbolRow'

class UpgradeSuccessPage extends React.Component{

	componentDidMount(){
		if(window.analytics){
			window.analytics.page('Upgrade',{stage:'Success'})
		}
		if (typeof window.ga === 'function') {
			window.ga('set', 'page',  '/upgrade-success-page')
			window.ga('send', 'pageview')
  		}
	}



	render(){	
		const {trialUsed}=this.props
		
		const trialPurchase = !trialUsed

		return(
			<div className='upgrade upgrade--success marketing'>
				<div className='upgrade-closeBtn' onClick={this.props.hideModal}>
					<Icon name='circle-with-close' />
				</div>

				<div className='upgrade--success-header'>
					<span role='img' aria-label="Celebration">🎉</span> &nbsp; Welcome to <span className='upgrade--success-header--plickersPro-plickers'>plickers</span><span className='upgrade--success-header--plickersPro-pro'>pro</span> &nbsp; 🎉
				</div>


				{trialPurchase &&
					<div className='upgrade--success-sub'>
						You are now on a 14-day free trial. Here's everything that's included:
					</div>
				}

				{!trialPurchase &&
					<div className='upgrade--success-sub'>
						Here's everything that's included:
					</div>
				}

				<UpgradeProFeaturesSymbolRow />
				
				<div className='upgrade-success-btnContainer'>
					<button className='upgrade--success-doneBtn' onClick={this.props.hideModal}>
						Go to your upgraded Plickers
					</button>
				</div>
				
				{trialPurchase &&
					<div className='upgrade--success-cancelSub'>
						You can cancel your trial at any time by going to "Account", then "Cancel Trial".
					</div>
				}

			</div>
			
		)	
	}
				
}




export default UpgradeSuccessPage


